module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gEjU1"))).then(() => module.bundle.root('d181N'));